
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.104 17.917h-3.75a1.21 1.21 0 01-.89-.36 1.21 1.21 0 01-.36-.89c0-.355.12-.652.36-.891.24-.24.536-.36.89-.36h3.75v-3.75c0-.354.12-.65.36-.89s.536-.36.89-.36c.355 0 .652.12.891.36.24.24.36.537.36.89v3.75h3.75c.353 0 .65.12.89.36s.36.537.36.891-.12.651-.36.89a1.21 1.21 0 01-.89.36h-3.75v3.75c0 .354-.12.65-.36.89s-.537.36-.891.36c-.355 0-.652-.12-.89-.36a1.21 1.21 0 01-.36-.89v-3.75zm-15.208 1.57c-1.604 0-2.978-.571-4.12-1.713-1.142-1.143-1.713-2.516-1.713-4.12s.57-2.978 1.713-4.12c1.142-1.142 2.516-1.713 4.12-1.713s2.977.57 4.12 1.713c1.142 1.142 1.713 2.516 1.713 4.12s-.571 2.977-1.713 4.12c-1.143 1.142-2.516 1.713-4.12 1.713zm-12.5 10.16v-1.173c0-.816.222-1.572.665-2.267a4.44 4.44 0 011.777-1.604 24.175 24.175 0 014.986-1.818 21.58 21.58 0 0110.144 0 24.175 24.175 0 014.985 1.818 4.44 4.44 0 011.778 1.604c.443.695.665 1.451.665 2.267v1.173c0 .703-.247 1.301-.739 1.794a2.442 2.442 0 01-1.793.738H4.928c-.703 0-1.3-.246-1.793-.738a2.441 2.441 0 01-.74-1.794zm2.5.032h20v-1.205c0-.337-.098-.65-.294-.937a2.22 2.22 0 00-.796-.704 21.412 21.412 0 00-4.392-1.607 18.985 18.985 0 00-9.036 0c-1.492.364-2.957.9-4.392 1.607a2.22 2.22 0 00-.797.704c-.195.287-.293.6-.293.937v1.205zm10-12.692a3.21 3.21 0 002.354-.979 3.21 3.21 0 00.98-2.354 3.21 3.21 0 00-.98-2.354 3.21 3.21 0 00-2.354-.98 3.21 3.21 0 00-2.354.98 3.21 3.21 0 00-.98 2.354c0 .916.327 1.701.98 2.354a3.21 3.21 0 002.354.98z","fill":"#fff"}})])
          )
        }
      }
    